<template>
  <div class="wrapper_btn_close"></div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'CloseButton'
});
</script>

<style scoped>
.wrapper_btn_close {
  width: 43px;
  height: 43px;
  border: 5px solid #ffffff;

  border-radius: 50%;
  position: relative;
}

.wrapper_btn_close:after {
  content: '';
  display: block;
  width: 28px;
  height: 5px;
  background-color: white;
  position: absolute;
  top: 14px;
  left: 3px;
  transform: rotate(45deg);
}

.wrapper_btn_close:before {
  content: '';
  display: block;
  width: 28px;
  height: 5px;
  background-color: white;
  position: absolute;
  top: 14px;
  left: 3px;
  transform: rotate(-45deg);
}
</style>
